import { render, staticRenderFns } from "./ClaimsGraphs.vue?vue&type=template&id=f8b566b2&scoped=true"
import script from "./ClaimsGraphs.vue?vue&type=script&lang=ts"
export * from "./ClaimsGraphs.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsGraphs.vue?vue&type=style&index=0&id=f8b566b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b566b2",
  null
  
)

export default component.exports